import { apiRequest } from '../../apiRequest'

export const getProfileInfo = () => apiRequest('/pro/settings/profile/').get()

export const setProInfo = (data) => apiRequest('/pro/settings/profile/').put(data)

export const uploadPhoto = (data) => apiRequest('/pro/settings/upload-photo/').post(data)

export const getYoutubeVideos = () => apiRequest('/pro/youtube-videos/').get()
